export default "__VITE_ASSET__JHa_Q9BM__"